import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import UnitTypeGroupsListContainer from './containers/areas-list/unit-type-group-list.container';
/**
 * function UnitTypeGroupModule components
 */
export const UnitTypeGroupModule: React.FC = () => {
  return (
    <>
      <Route exact path={APP_ROUTES.UNIT_TYPE_GROUP_MODULE.FULL_PATH}>
        <Redirect to={(APP_ROUTES.UNIT_TYPE_GROUP_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH} />
      </Route>
      <Route
        path={(APP_ROUTES.UNIT_TYPE_GROUP_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH}
        component={UnitTypeGroupsListContainer}
      />
    </>
  );
};
